import Vue from 'vue';
import VueRouter from 'vue-router';
import { getLoginUser } from '../utils/localStorage';

// 相同路由push时错误捕获...
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

import defaultRoutes from './default';
import apiRoutes from './api';

let routes = defaultRoutes;
if (process.env.VUE_APP_ROUTE_MODEL == 2) {
  routes = apiRoutes;
}

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior: () => ({ x: 0, y: 0 }),
});

router.beforeEach((to, from, next) => {
  // const excludeRouteName = [
  //   'Login',
  //   'Register',
  //   'LiveReplay',
  //   'LiveSpread',
  //   'LiveScene',
  //   'LiveEnd',
  //   'LiveIndex',
  //   'LiveList',
  //   'AppDown',
  //   'ExercisePreview',
  //   'AuthCourse',
  //   'AuthProduct',
  //   'HttpNotFound',
  // ];
  // if (!isLogin() && !excludeRouteName.includes(to.name)) {
  //   next({ name: 'Login', query: { redirect: to.fullPath } });
  // } else {
  //   next();
  // }
  if (to.matched.some(res => res.meta.requiredAuth)) {
    //登录信息及授权判断
    if (!isLogin()) {
      if (to.name == "LiveReplay") { // 回放
        next();
      } else if (to.name == "LiveSpread") { // 直播
        next({ name: 'LoginLive', query: { redirect: to.fullPath } });
      } else {
        next({ name: 'Login', query: { redirect: to.fullPath } });
      }
    } else {
      next();
    }
  } else {
    next();
  }
});

const base64 = require('js-base64').Base64;
function isLogin() {
  const userInfo = getLoginUser();
  const cookie = Vue.$cookies.get('coksinfo');
  if (cookie && userInfo && Object.keys(userInfo).length > 0) {
    const username = base64.decode(cookie);
    return username == userInfo.userName;
  }
  return false;
}

export default router;
